import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiResponse, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { Category } from "../../categories.types";
import { requestGetParentCategories } from "./getParentCategories.request";

const useGetParentCategories = <T>(
  parentCategoryId: string,
  options?: QueryOptions<ApiResponse<T[], []>, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();
  const QUERY_KEY = ["category-admin", "child", parentCategoryId];

  const { data: categories = [], ...rest } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      return await requestGetParentCategories<T>(parentCategoryId);
    },
    enabled: !!parentCategoryId,
    ...options
  });

  const setCategories = (newCategories: Category[]) => {
    queryClient.setQueriesData(QUERY_KEY, newCategories);
  };

  return { categories, setCategories, ...rest };
};

export default useGetParentCategories;
